const TRACK_URL = process.env.REACT_APP_ROADIE_TRACK_URL

export function isTrackURL() {
  return TRACK_URL === `${window.location.protocol}//${window.location.host}`
}

export function redirectToTrackUrl() {
  window.location.href = `${TRACK_URL}${window.location.pathname}`
}